import { appConfig } from 'config/app';
import { ChannelType, ICreateIdentity, IIdentity, IResetIdentity, IResetIdentityRequest, IVerifyIdentity, IVerifyIdentityRequest } from 'types';
import { ApiClient } from './ApiClient';

export const Identity = {
  createIdentity: (body: ICreateIdentity) => ApiClient.post<IIdentity>(`${appConfig.API_BASE_URL}/v1/identity`, body),
  verifyIdentity: (identityId: string, body: IVerifyIdentityRequest) => ApiClient.put<IVerifyIdentity>(`${appConfig.API_BASE_URL}/v1/identity/${identityId}/verify`, body),
  resendVerificationCode: (identityId: string, channel?: ChannelType.CALL) => ApiClient.put<IIdentity>(`${appConfig.API_BASE_URL}/v1/identity/${identityId}/resend`, { channel }),
  resetIdentity: (identityId: string, body: IResetIdentityRequest) => ApiClient.put<IResetIdentity>(`${appConfig.API_BASE_URL}/v1/identity/${identityId}/reset`, body),
};
